module.exports = __webpack_public_path__ + "Assets/aok-icons-linear.dc4771db.ttf";